import usePageYOffset from 'hooks/usePageYOffset';
import React, { useState } from 'react';

const withLoadingPage = (Component) => {
  const LoadingPageComponent = (props) => {
    const [pageYOffset, setPageYOffset] = useState(0);
    usePageYOffset(setPageYOffset);

    const newProps = {
      ...props,
    };

    return (
      <Component
        {...newProps}
        pageYOffset={pageYOffset}
        loadingStyles={{ left: 0 }}
      />
    );
  };
  return LoadingPageComponent;
};

export default withLoadingPage;
